/**
 *? Collection of tool handlers for the MiKomic editor
 *  Each tool implements methods for handling user interactions
 */

const tool_handlers = {
    // Select tool - allows selecting images and other elements
    select: {
        mouse_down(app, e) {       
            if (e.evt.button !== 0) return;

            const target = e.target;
            var target_element = target.name();
            
            //console.log('Target element:', target_element);
            // --- Shift Key Logic for Multi-Selection ---
            if (e.evt.shiftKey) {
                app.balloon_edit_mode_active = false; // Reset flag
                // Check if target is a valid selectable object (image, balloon, or standalone text)
                const is_selectable_object = target_element === 'panel_image' || target_element === 'balloon_shape' || target_element === 'balloon_text' || target_element === 'text_content';
                let object_to_select = null;

                if (is_selectable_object) {
                    if (target_element === 'panel_image') {
                        object_to_select = target;
                    }                     
                    else if (target_element === 'text_content') {
                        // Find the parent standalone text group
                        let parent = target.getParent();
                        while (parent) {
                            if (parent.name() === 'standalone_text') {
                                object_to_select = parent;
                                break;
                            }
                            parent = parent.getParent();
                        }
                    } 
                    else { // balloon_shape or balloon_text
                        // Find the parent balloon group
                        let parent = target.getParent();
                        while (parent) {
                            if (parent.name() === 'panel_balloon') {
                                object_to_select = parent;
                                break;
                            }
                            parent = parent.getParent();
                        }
                    }
                }

                // If a valid, unlocked object was clicked
                if (object_to_select && object_to_select.getAttr('locked') !== true) {
                    const current_nodes = app.transformer.nodes();
                    const index = current_nodes.indexOf(object_to_select);

                    if (index > -1) { // Object is already selected, deselect it
                        current_nodes.splice(index, 1);
                    } else { // Object is not selected, add it
                        current_nodes.push(object_to_select);
                    }

                    // Update the transformer with the new selection
                    app.transformer.nodes(current_nodes);

                    // Update app.selected_object to the last clicked/toggled object
                    // This keeps single-object UI controls somewhat relevant
                    app.selected_object = object_to_select;                    
                    app.update_ui_from_selected_object(); // Update UI based on this last object
                    
                    if (app.selected_object_array.length < 1) { //only for first object
                        app.show_transformer(object_to_select);
                    }

                    //add to selected_object_array array
                    app.add_object_to_array(object_to_select);

                    app.ui_layer.batchDraw(); // Redraw UI layer
                    return; // Prevent default single-selection logic
                } else {
                    // Shift+click on non-selectable element (background, locked item, etc.)
                    // Do nothing, keep current selection
                    return;
                }
            }
            // --- End Shift Key Logic ---

            var invalid_target = target_element === "back" || target_element.includes("anchor");
            if (invalid_target)
            {
                return;
            }

            if (target_element === '' && app.selected_object && app.transformer) {
                // Use raw pointer position relative to the stage container
                const pos = app.stage.getPointerPosition();
                if (pos) {
                    // Find the transformer's background element
                    const back_element = app.transformer.findOne('.back');

                    if (back_element) {
                        // Get the back element's bounding box relative to the stage container (no arguments)
                        const back_box = back_element.getClientRect();

                        // Log coordinates for debugging comparison - THESE SHOULD NOW BE IN THE SAME SYSTEM
                        //console.log('Pointer position (relative to container):', pos);
                        //console.log('Transformer back element bounds (relative to container):', back_box);

                        // Check if pointer is inside the back element's bounds 
                        if (back_box && // Ensure back_box is valid
                            pos.x >= back_box.x && pos.x <= back_box.x + back_box.width &&
                            pos.y >= back_box.y && pos.y <= back_box.y + back_box.height)
                        {
                            // This specific case for dragging the background was already partially handled,
                            // but the priority check above makes it more robust.
                            // We might still need startDrag here if Konva doesn't automatically handle it
                            // when clicking the transformer background specifically.
                            // app.select_object(app.selected_object); // Re-selecting might not be needed
                            if (app.selected_object.draggable()) { // Check if draggable before starting
                                app.selected_object.startDrag(e);
                            }
                            return; // Prevent deselection ONLY if click is inside these bounds
                        } else {
                            // Click is outside transformer's back bounds -> Proceed to deselect
                        }
                    } else {
                        // Back element not found (unexpected) -> Proceed to deselect
                    }
                } else {
                     // Could not get pointer position -> Proceed to deselect
                }
            }

            app.deselect_object();
            if (app.active_subtool !== 'divider') {
                app.deselect_panel();
            }
              
            function __select_panel(){               
                
                //select panel under element if any
                const adjusted_pos = app.get_pointer_position();
                if (!adjusted_pos) return;                    

                // Find topmost panel under pointer (reverse order to get highest z-index first)
                let topmost_panel = null;
                for (let i = app.panels.length - 1; i >= 0; i--) {
                    const panel = app.panels[i];

                    //ignore global panel
                    if (panel.getAttr('is_global')){
                        continue;
                    }

                    const point = {
                        x: adjusted_pos.x - panel.x(),
                        y: adjusted_pos.y - panel.y()
                    };
                    
                    if (app.is_point_in_polygon(point, panel.points)) {
                        topmost_panel = panel;
                        break;
                    }
                }
                
                if (topmost_panel) {
                    app.deselect_panel();
                    app.select_panel(topmost_panel);
                }
            }
            switch (target_element) {
                case 'panel_background':      
                    __select_panel();             
                break;
                case 'text_content':
                    // Find the parent standalone text group
                    const text_group = target.parent;
                    if (text_group && text_group.getAttr('object_type') === 'standalone_text') {
                        // Check if the object belongs to a global panel
                        let is_global_object = false;
                        let global_panel = null;

                        for (const panel of app.panels) {
                            if (panel.getAttr('is_global') && panel.content_group.findOne('#' + text_group.id())) {
                                is_global_object = true;
                                global_panel = panel;
                                break;
                            }
                        }
                        
                        // Only select underlying panel if the object is not from global panel
                        if (!is_global_object) {
                            __select_panel();
                        } else {
                            // For global objects, perform proper panel selection first
                            app.deselect_all();
                            app.select_panel(global_panel);
                        }

                        // Select the text group
                        app.select_object(text_group);
                    }
                break;
                case 'balloon_shape':
                case 'balloon_text':
                    // Find the parent balloon group
                    const balloon_group = target.parent;
                    if (balloon_group && balloon_group.getAttr('object_type') === 'balloon') {
                        // Prevent panel selection if balloon is in global panel
                        let is_global_object = false;
                        for (const panel of app.panels) {
                            if (panel.getAttr('is_global') && panel.content_group.findOne('#' + balloon_group.id())) {
                                is_global_object = true;
                                break;
                            }
                        }
                        if (!is_global_object) {
                            __select_panel();
                        }
                        // Then select the balloon group
                        if (app.balloon_edit_mode_active == false)
                        {
                            app.select_object(balloon_group);
                        }
                    }
                    break;
                case '':
                    app.deselect_all();
                    break;
                case 'panel_image':
                    // Don't select if image is locked
                    if (target.getAttr('locked') === true) {
                        __select_panel();
                        return;
                    }

                    // Check if the object belongs to a global panel
                    let is_global_object = false;
                    let global_panel = null;

                    for (const panel of app.panels) {
                        if (panel.getAttr('is_global') && panel.content_group.findOne('#' + target.id())) {
                            is_global_object = true;
                            global_panel = panel;
                            break;
                        }
                    }
                    
                    // Only select underlying panel if the object is not from global panel
                    if (!is_global_object) {
                        __select_panel();   
                    }
                    else {
                        // For global objects, perform proper panel selection first 
                        // to ensure correct initialization of drag and drop
                        app.deselect_all();
                        app.select_panel(global_panel);
                    }

                    app.select_object(target);
                    break;
                default:
                    break;
            } 
        }, 
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
            }

            // Set all unlocked images to be draggable and listening
            app.panels.forEach(panel => {
                // Make unlocked images draggable and enable event listening
                panel.content_group.find('.panel_image').forEach(img => {
                    const is_locked = img.getAttr('locked') === true;
                    // Only make draggable if not locked
                    img.draggable(!is_locked);
                    // Control event listening based on locked state
                    img.listening(!is_locked);
                });
                
                // Enable balloon interactivity when select tool is active
                panel.content_group.find('.panel_balloon').forEach(balloon => {
                    const is_locked = balloon.getAttr('locked') === true;
                    balloon.draggable(!is_locked);
                    // Control event listening based on locked state
                    balloon.listening(!is_locked);
                });
                
                // Handle standalone text elements
                panel.content_group.find('.standalone_text').forEach(text => {
                    const is_locked = text.getAttr('locked') === true;
                    text.draggable(!is_locked);
                    // Control event listening based on locked state
                    text.listening(!is_locked);
                });
            });
        },
        deactivate(app) {
            app.deselect_object();
            app.panels.forEach(panel => {
                // Disable image dragging
                panel.content_group.find('.panel_image').forEach(img => {
                    img.draggable(false);
                });
                
                // Disable balloon dragging when select tool is not active
                panel.content_group.find('.panel_balloon').forEach(balloon => {
                    balloon.draggable(false);
                });
            });
            
            // Clear any balloon edit modes
            app.clear_balloon_edit_modes();
        }
    },
    
    // Select panel tool - selects panels regardless of content
    select_panel: {
        mouse_down(app, e) {
            // Only respond to left mouse button
            if (e.evt.button !== 0) return;

            if (app.active_subtool === 'divider') {
                return;
            }
            
            // If panel transform is active, don't select other panels
            if (app.panel_transform_active || app.panel_edit_mode_active) {
                return;
            }
            
            // Use adjusted coordinates that account for zoom and pan
            const adjusted_pos = app.get_pointer_position();
            if (!adjusted_pos) return;
            
            // Find panel under adjusted pointer (topmost panel first)
            var panel_found = false;
            for (let i = app.panels.length - 1; i >= 0; i--) {
                const panel = app.panels[i];

                //ignore global panel
                if (panel.getAttr('is_global')){
                    continue;
                }

                const point = {
                    x: adjusted_pos.x - panel.x(),
                    y: adjusted_pos.y - panel.y()
                };
                
                if (app.is_point_in_polygon(point, panel.points)) {
                    app.deselect_panel();
                    app.select_panel(panel);
                    // Also deselect any images when selecting panels
                    app.deselect_object();
                    panel_found = true;
                    break;
                }
            }
            
            // If no panel was found under the click, deselect current panel
            if (!panel_found) {
                app.deselect_panel();
            }

        },
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'cell';
            }

            app.deselect_object();
            app.panels.forEach(panel => {
                // Disable image dragging
                panel.content_group.find('.panel_image').forEach(img => {
                    img.draggable(false);
                });
                
                // Disable balloon dragging when select tool is not active
                panel.content_group.find('.panel_balloon').forEach(balloon => {
                    balloon.draggable(false);
                });
            });
            
            // Clear any balloon edit modes when activating this tool
            app.clear_balloon_edit_modes();
        },
        deactivate(app) {
            // Don't deselect panel when changing tools - keep panel selection
        }
    },

    // Zoom tool implementation - corrected version
    zoom: {
        is_dragging: false,
        drag_start_pos: null,
        drag_start_zoom: 1,
        
        mouse_down(app, e) {
            // Only handle left mouse button (button 0)
            if (e.evt.button !== 0) return;
            
            const pointer_pos = app.stage.getPointerPosition();
            if (!pointer_pos) return;
            
            // Save starting position for drag zoom
            this.is_dragging = true;
            this.drag_start_pos = pointer_pos;
            this.drag_start_zoom = app.canvas_zoom;
            
            // For simple click (not dragging yet), apply immediate zoom
            if (!e.evt.shiftKey) {
                const zoom_factor = e.evt.altKey ? 0.9 : 1.1;
                app.adjust_zoom(zoom_factor, pointer_pos, true);
            }
        },
        
        mouse_move(app, e) {
            if (!this.is_dragging) return;
            
            const pointer_pos = app.stage.getPointerPosition();
            if (!pointer_pos || !this.drag_start_pos) return;
            
            // Calculate drag distance horizontally
            const drag_distance = pointer_pos.x - this.drag_start_pos.x;
            
            // Skip tiny movements
            if (Math.abs(drag_distance) < 2) return;
            
            // Calculate new zoom based on drag distance
            // Moving right increases zoom, left decreases
            const zoom_change = 1 + (drag_distance / 300);
            const new_zoom = this.drag_start_zoom * zoom_change;
            
            // Apply zoom with limits
            app.set_zoom_level(new_zoom, this.drag_start_pos, true);
        },
        
        mouse_up(app, e) {
            this.is_dragging = false;
            this.drag_start_pos = null;
        },
        
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'zoom-in';
                
                // Add mouse move/up and touch move/end events for drag zoom
                app.stage.on('mousemove.zoom touchmove.zoom', (e) => { // Added touchmove
                    this.mouse_move(app, e);
                });

                app.stage.on('mouseup.zoom touchend.zoom', (e) => { // Added touchend
                    this.mouse_up(app, e);
                });
            }
        },
        
        deactivate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
                // Remove all namespaced listeners (mousemove, mouseup, touchmove, touchend)
                app.stage.off('.zoom');
                // window.removeEventListener('keydown', app.zoom_key_handler); // Keep existing logic for key handlers if any
                // window.removeEventListener('keyup', app.zoom_key_handler);
            }
        }
    },
    
    // Hand/pan tool implementation
    hand: {
        is_dragging: false,
        last_pos: null,
        
        mouse_down(app, e) {
            // Only handle left mouse button (button 0)
            if (e.evt.button !== 0) return;
            
            this.is_dragging = true;
            this.last_pos = app.stage.getPointerPosition();
            app.stage.container().style.cursor = 'grabbing';
        },
        
        mouse_move(app, e) {
            if (!this.is_dragging || !this.last_pos) return;
            
            const pos = app.stage.getPointerPosition();
            if (!pos) return;
            
            // Calculate movement
            const dx = pos.x - this.last_pos.x;
            const dy = pos.y - this.last_pos.y;
            
            // Apply movement
            app.stage.x(app.stage.x() + dx);
            app.stage.y(app.stage.y() + dy);
            app.stage.batchDraw();
            
            // Update last position
            this.last_pos = pos;
        },
        
        mouse_up(app, e) {
            this.is_dragging = false;
            this.last_pos = null;
            app.stage.container().style.cursor = 'grab';
        }, 
        
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'grab';
                
                // Add listeners for both mouse and touch start
                app.stage.on('mousedown.hand touchstart.hand', (e) => { // Added touchstart
                    this.mouse_down(app, e);
                });

                // Add listeners for both mouse and touch move
                app.stage.on('mousemove.hand touchmove.hand', (e) => { // Added touchmove
                    this.mouse_move(app, e);
                });

                // Add listeners for both mouse and touch end
                app.stage.on('mouseup.hand touchend.hand', (e) => { // Added touchend
                    this.mouse_up(app, e);
                });
            }
        },
        
        deactivate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
                // Remove all namespaced listeners (mousedown, mousemove, mouseup, touchstart, touchmove, touchend)
                app.stage.off('.hand');
            }
        }
    },
    
    // Add panel tool implementation
    add_panel: {
        is_drawing: false,
        start_point: null,

        async mouse_down(app, e) {
            if (e.evt.button !== 0) return;
            
            this.is_drawing = true;
            
            // Save initial mouse position (adjusted for zoom/pan)
            const pos = app.get_pointer_position();
            this.start_point = pos;
            
            // Create visual guide while drawing
            app.panel_preview = new Konva.Rect({
                x: pos.x,
                y: pos.y,
                width: 1,
                height: 1,
                stroke: '#00ff00',
                strokeWidth: 2,
                dash: [5, 5],
                listening: false
            });
            app.ui_layer.add(app.panel_preview);
            
            // Set up move and release events for mouse and touch
            app.stage.on('mousemove.panel touchmove.panel', (moveEvent) => {
                if (!this.is_drawing) return;
                
                const current_pos = app.get_pointer_position();
                if (!current_pos || !this.start_point) return;
                
                // Update preview rectangle
                const width = current_pos.x - this.start_point.x;
                const height = current_pos.y - this.start_point.y;
                
                app.panel_preview.width(width);
                app.panel_preview.height(height);
                app.ui_layer.batchDraw();
            });
            
            app.stage.on('mouseup.panel touchend.panel', (upEvent) => { 
                if (!this.is_drawing) return;
                
                const end_point = app.get_pointer_position();
                if (!end_point || !this.start_point) return;
                
                // Clean up preview
                if (app.panel_preview) {
                    app.panel_preview.destroy();
                    app.panel_preview = null;
                }
                
                // Calculate dimensions and position
                const width = Math.abs(end_point.x - this.start_point.x);
                const height = Math.abs(end_point.y - this.start_point.y);
                
                // Only create if big enough
                if (width > 50 && height > 50) {
                    // Check premium limits for panel creation
                    const content_panels = app.panels.filter(panel => !panel.getAttr('is_global'));
                    if (!app.check_local_restriction('max_panels_per_page', content_panels.length)) {
                        // Clean up state
                        this.is_drawing = false;
                        this.start_point = null;
                        
                        // Remove temporary listeners
                        app.stage.off('mousemove.panel touchmove.panel');
                        app.stage.off('mouseup.panel touchend.panel');
                        
                        return;
                    }
                    
                    // Calculate top-left position of the drawn rectangle
                    const left_x = Math.min(this.start_point.x, end_point.x);
                    const top_y = Math.min(this.start_point.y, end_point.y);
                    
                    // Create rectangle points (clockwise)
                    const points = [
                        0, 0,
                        width, 0,
                        width, height,
                        0, height
                    ];
                    
                    // Create new panel
                    const panel = new Konva.Group({
                        x: left_x,
                        y: top_y,
                        name: 'panel_group',
                        id: 'panel_' + Date.now()
                    });
                    
                    // Add panel attribute for identification
                    panel.setAttr('is_panel', true);
                    panel.setAttr('respect_margins', true); // Default to respecting margins
                    
                    // Create background (use panel color like other panels)
                    const background = new Konva.Line({
                        points: points,
                        closed: true,
                        fill: app.panel_color,
                        name: 'panel_background'
                    });
                    panel.add(background);
                    
                    // Create content group
                    const content_group = new Konva.Group({
                        name: 'content_group',
                        listening: true
                    });
                    
                    // Set clip function for content
                    content_group.clipFunc((ctx) => {
                        ctx.beginPath();
                        for (let i = 0; i < points.length; i += 2) {
                            const x = points[i];
                            const y = points[i + 1];
                            if (i === 0) ctx.moveTo(x, y);
                            else ctx.lineTo(x, y);
                        }
                        ctx.closePath();
                    });
                    panel.add(content_group);
                    
                    // Create outline
                    const outline = new Konva.Line({
                        points: points,
                        closed: true,
                        stroke: app.outline_color,
                        strokeWidth: app.outline_width,
                        name: 'panel_outline',
                        listening: false
                    });
                    panel.add(outline);
                    
                    // Store references
                    panel.outline = outline;
                    panel.background = background;
                    panel.content_group = content_group;
                    panel.points = points;
                    
                    // Add panel to layer
                    app.panels_layer.add(panel);
                    
                    // Ensure global panel stays on top if it exists
                    const global_panel = app.panels.find(p => p.getAttr('is_global'));
                    if (global_panel) {
                        global_panel.moveToTop();
                    }
                    
                    // Add to panels array
                    app.panels.push(panel);
                    
                    // Select the new panel
                    app.change_tool('select_panel');
                    app.select_panel(panel);
                    
                    // Force redraw
                    app.redraw();
                    
                    // Record in history
                    app.push_to_history('create_panel');
                }
                
                // Clean up state
                this.is_drawing = false;
                this.start_point = null;
                
                // Remove temporary listeners
                app.stage.off('mousemove.panel touchmove.panel');
                app.stage.off('mouseup.panel touchend.panel');
                
                app.ui_layer.batchDraw();
            });
        },
        
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'crosshair';
            }
        },
        
        deactivate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
            }
            
            // Clean up any in-progress drawing
            if (app.panel_preview) {
                app.panel_preview.destroy();
                app.panel_preview = null;
            }
            
            // Remove temporary listeners using namespace
            app.stage.off('.panel');
        }
    },
    
    // Balloon tool implementation
    add_balloon: {
        is_drawing: false,
        start_point: null,

        async mouse_down(app, e) {
            if (e.evt.button !== 0) return;
            
            // Only proceed if a panel is selected
            if (!app.selected_panel) {
                app.status_message = app.get_t('status.select_panel_first');
                return;
            }
            
            this.is_drawing = true;
            
            // Save initial mouse position (adjusted for zoom/pan)
            const pos = app.get_pointer_position();
            this.start_point = pos;
            
            // Create visual guide while drawing
            app.balloon_preview = new Konva.Rect({
                x: pos.x,
                y: pos.y,
                width: 1,
                height: 1,
                stroke: '#0096ff',
                strokeWidth: 1,
                dash: [5, 5],
                listening: false
            });
            app.ui_layer.add(app.balloon_preview);
            
            // Set up move and release events for mouse and touch
            app.stage.on('mousemove.balloon touchmove.balloon', (moveEvent) => { // Added touchmove
                if (!this.is_drawing) return;
                
                const current_pos = app.get_pointer_position();
                if (!current_pos || !this.start_point) return;
                
                // Update preview rectangle
                const width = current_pos.x - this.start_point.x;
                const height = current_pos.y - this.start_point.y;
                
                app.balloon_preview.width(width);
                app.balloon_preview.height(height);
                app.ui_layer.batchDraw();
            });
            
            app.stage.on('mouseup.balloon touchend.balloon', (upEvent) => { 
                if (!this.is_drawing) return;
                
                const end_point = app.get_pointer_position();
                if (!end_point || !this.start_point) return;
                
                // Clean up preview
                if (app.balloon_preview) {
                    app.balloon_preview.destroy();
                    app.balloon_preview = null;
                }
                
                // Calculate dimensions and center position
                const width = Math.abs(end_point.x - this.start_point.x);
                const height = Math.abs(end_point.y - this.start_point.y);
                
                // Only create if big enough
                if (width > 30 && height > 30) {
                    const panel = app.selected_panel;

                    // Calculate center position of the drawn rectangle
                    const center_x = (this.start_point.x + end_point.x) / 2;
                    const center_y = (this.start_point.y + end_point.y) / 2;
                    
                    // Calculate position relative to panel
                    const rel_center_x = center_x - panel.x();
                    const rel_center_y = center_y - panel.y();
                    
                    // Check premium limits before creating balloon
                    const all_balloons = [];
                    app.panels.forEach(panel => {
                        if (panel.content_group) {
                            const balloons = panel.content_group.find(node => node.getAttr('object_type') === 'balloon');
                            all_balloons.push(...balloons);
                        }
                    });
                    
                    // Check balloons per page limit
                    const current_balloon_count = all_balloons.length;
                    if (!app.check_local_restriction('max_balloons_per_page', current_balloon_count)) {
                        // Clean up state
                        this.is_drawing = false;
                        this.start_point = null;
                        
                        // Remove temporary listeners
                        app.stage.off('mousemove.balloon touchmove.balloon');
                        app.stage.off('mouseup.balloon touchend.balloon');
                        
                        return;
                    }
                    
                    // Check layers per panel limit
                    const current_layer_count = app.get_panel_layer_count(panel);
                    if (!app.check_local_restriction('max_layers_per_panel', current_layer_count)) {
                        // Clean up state
                        this.is_drawing = false;
                        this.start_point = null;
                        
                        // Remove temporary listeners
                        app.stage.off('mousemove.balloon touchmove.balloon');
                        app.stage.off('mouseup.balloon touchend.balloon');
                        
                        return;
                    }

                    // Create balloon directly at the center position
                    var target = app.create_balloon(app.active_balloon_type, {
                        x: rel_center_x,
                        y: rel_center_y,
                        width: width,
                        height: height,
                        fill: app.preferences.balloon_defaults.fill,
                        stroke: app.preferences.balloon_defaults.stroke,
                        strokeWidth: app.preferences.balloon_defaults.stroke_width,
                    });
                    
                    // Change to select tool and select the balloon
                    app.change_tool('select');
                    app.select_object(target);
                }
                
                // Clean up state
                this.is_drawing = false;
                this.start_point = null;
                
                // Remove temporary listeners
                app.stage.off('mousemove.balloon touchmove.balloon');
                app.stage.off('mouseup.balloon touchend.balloon');
                
                app.ui_layer.batchDraw();
            });
        },
        
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'crosshair';
            }            

            // Clear any balloon edit modes when activating this tool
            app.clear_balloon_edit_modes();        
            app.refresh_lucide();
        },
        
        deactivate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
            }
            
            // Clean up any in-progress drawing
            if (app.balloon_preview) {
                app.balloon_preview.destroy();
                app.balloon_preview = null;
            }
            
            // Remove temporary listeners using namespace
            app.stage.off('.balloon');
        }
    },

    // Tool for adding pointers to balloons
    add_pointer: {
        is_drawing: false,
        start_point: null, // Global stage coordinates (adjusted for zoom/pan)
        preview_line: null,
        selected_balloon: null, // The balloon being modified by this tool's state
        was_dragged: false, // Flag to check if mouse moved significantly after mousedown
        started_on_balloon: false, // Flag to track if drag started on the selected balloon

        mouse_down(app, e) {
            if (e.evt.button !== 0) return; // Only left click            

            const target = e.target;
            const target_name = target.name();
            let clicked_balloon_group = null;
            this.started_on_balloon = false; // Reset flag

            app.deselect_object(); // Deselect any previously selected object
            app.transformer.shouldOverdrawWholeArea(false); // Disable overdraw for pointer tool

            // Check if the click target is part of a balloon
            if (target_name === 'balloon_shape' || target_name === 'balloon_text') {
                let parent = target.getParent();
                while (parent) {
                    if (parent.name() === 'panel_balloon') {
                        clicked_balloon_group = parent;
                        break;
                    }
                    parent = parent.getParent();
                }
            }

            const pos = app.get_pointer_position();
            if (!pos) return;

            // --- Handle click based on target ---
            if (clicked_balloon_group) {
                // Clicked ON a balloon: Reset state, select this balloon, prepare for drawing.
                this.reset_state(app); // Reset state at the beginning as requested                
                this.selected_balloon = clicked_balloon_group;
                app.show_minimal_transformer(this.selected_balloon);
                // Make the balloon non-draggable temporarily
                this.selected_balloon.draggable(false); // Restored as requested
                this.started_on_balloon = true; // Set flag

                // Initialize drawing state
                this.is_drawing = true;
                this.was_dragged = false;
                this.start_point = pos; // Global start position

                // Create preview line
                this.preview_line = new Konva.Line({
                    points: [this.start_point.x, this.start_point.y, this.start_point.x, this.start_point.y],
                    stroke: '#0096ff',
                    strokeWidth: 2 / app.canvas_zoom,
                    dash: [5 / app.canvas_zoom, 5 / app.canvas_zoom],
                    listening: false,
                    name: 'pointer_preview'
                });
                app.ui_layer.add(this.preview_line);
                app.ui_layer.batchDraw();

                // Add temporary listeners
                app.stage.off('.pointer');
                app.stage.on('mousemove.pointer touchmove.pointer', evt => this.mouse_move(app, evt));
                app.stage.on('mouseup.pointer touchend.pointer', evt => this.mouse_up(app, evt));

            } else {
                // Clicked OUTSIDE a balloon
                // Check if a balloon was previously selected AND still exists on stage
                if (this.selected_balloon && this.selected_balloon.getStage()) {
                    // Start drawing from here (for inward pointers).
                    this.is_drawing = true;
                    this.was_dragged = false;
                    this.start_point = pos; // Global start position is outside the balloon
                    this.started_on_balloon = false; // Explicitly false

                    // Create preview line
                    if (this.preview_line) this.preview_line.destroy(); // Clean up just in case
                    this.preview_line = new Konva.Line({
                        points: [this.start_point.x, this.start_point.y, this.start_point.x, this.start_point.y],
                        stroke: '#0096ff',
                        strokeWidth: 2 / app.canvas_zoom,
                        dash: [5 / app.canvas_zoom, 5 / app.canvas_zoom],
                        listening: false,
                        name: 'pointer_preview'
                    });
                    app.ui_layer.add(this.preview_line);
                    app.ui_layer.batchDraw();

                    // Add temporary listeners
                    app.stage.off('.pointer');
                    app.stage.on('mousemove.pointer touchmove.pointer', evt => this.mouse_move(app, evt));
                    app.stage.on('mouseup.pointer touchend.pointer', evt => this.mouse_up(app, evt));

                    // Keep the current this.selected_balloon
                    // Keep its transformer visible
                    app.show_minimal_transformer(this.selected_balloon);
                }
                // If clicked outside and no valid balloon selected, do nothing.
            }
        },

        mouse_move(app, e) {
            if (!this.is_drawing || !this.start_point || !this.preview_line) return;

            const pos = app.get_pointer_position();
            if (!pos) return;

            const dx = pos.x - this.start_point.x;
            const dy = pos.y - this.start_point.y;
            const move_threshold = 3 / app.canvas_zoom;
            if (!this.was_dragged && (Math.abs(dx) > move_threshold || Math.abs(dy) > move_threshold)) {
                this.was_dragged = true;
            }

            this.preview_line.points([this.start_point.x, this.start_point.y, pos.x, pos.y]);
            if (app.ui_layer) {
                app.ui_layer.batchDraw();
            }
        },

        async mouse_up(app, e) {
            app.transformer.shouldOverdrawWholeArea(true);

            if (!this.is_drawing || !this.start_point || !this.selected_balloon) {
                this.reset_state(app);
                return;
            }

            // Prevent pointer creation if mouse didn't move significantly (simple click)
            // and the click was not on the balloon itself (which implies intent to start pointer from balloon edge)
            if (!this.was_dragged && !this.started_on_balloon) {
                this.reset_state(app);
                return;
            }
            
            const end_point = app.get_pointer_position(); // World coordinates from canvas.js mixin
            if (!end_point) {
                console.error("Add Pointer: Could not get end_point from app.get_pointer_position().");
                this.reset_state(app);
                return;
            }

            const balloon = this.selected_balloon;
            if (!balloon || !balloon.getStage()) {
                console.error("Add Pointer: Selected balloon is not valid or not attached to the stage.");
                this.reset_state(app);
                return;
            }

            let local_start, local_end;
            try {
   

                // Get the balloon's absolute transform and invert it to map world coordinates to local
                const transform = balloon.getAbsoluteTransform().copy(); // Use copy to avoid modifying the original
                const inverted_transform = transform.invert();

                if (!inverted_transform) {
                    console.error("Add Pointer: Could not invert balloon transform. Balloon might have zero scale, be invisible, or not be part of the scene graph correctly.");
                    this.reset_state(app);
                    return;
                }
                
                // Check if balloon is in global panel
                const panel = balloon.getParent().getParent(); // balloon -> content_group -> panel
                const is_global_panel = panel && panel.getAttr('is_global') === true;
                const margin_offset = is_global_panel ? 0 : app.page_margin;

                local_start = {
                    x: this.start_point.x - margin_offset - balloon.x(),
                    y: this.start_point.y - margin_offset - balloon.y()
                };
                local_end = {
                    x: end_point.x - margin_offset - balloon.x(),
                    y: end_point.y - margin_offset - balloon.y()
                };

                // console.log("Add Pointer: local_start:", local_start, "local_end:", local_end);
                // console.log("Balloon coordinates:", balloon.x(), balloon.y());

                if (!local_start || !local_end) {
                    console.error("Add Pointer: Failed to transform one or both points to local coordinates. local_start:", local_start, "local_end:", local_end);
                    this.reset_state(app);
                    return;
                }

            } catch (error) {
                console.error("Add Pointer: Error during coordinate transformation:", error);
                this.reset_state(app);
                return;
            }

            const is_outward = !this.started_on_balloon; 

            // Get balloon shape data for intersection calculation
            const balloon_shape_node = balloon.findOne('.balloon_shape');
            if (!balloon_shape_node) {
                console.error("Add Pointer: Balloon shape node not found.");
                this.reset_state(app);
                return;
            }
            const balloon_shape_data = balloon_shape_node.data();
            if (!balloon_shape_data) {
                console.error("Add Pointer: Balloon shape data not found.");
                this.reset_state(app);
                return;
            }

            // Call get_line_shape_intersection_local with the existing local_start and local_end
            // These represent the user's intended pointer guide line relative to the balloon's origin.
            const intersection_result = await app.get_line_shape_intersection_local(local_start, local_end, balloon_shape_data);

            // Pass local_start, local_end, and the new intersection_result to handle_add_pointer.
            // The modification of where the pointer base/tip connects to the balloon edge
            // will be handled within handle_add_pointer using this intersection_result.
            app.handle_add_pointer(balloon, local_start, local_end, is_outward, app.active_pointer_type, intersection_result);
            
            this.reset_state(app);
        },

        reset_state(app) {
            if (this.selected_balloon) {
                 app.hide_transformer();
            }
            app.deselect_object();


            if (this.preview_line) {
                this.preview_line.destroy();
                this.preview_line = null;
                if (app.ui_layer) app.ui_layer.batchDraw();
            }

            app.stage.off('.pointer');

            this.is_drawing = false;
            this.start_point = null;
            this.selected_balloon = null;
            this.was_dragged = false;
            this.started_on_balloon = false; // Reset flag
        },

        activate(app) {
            if (app.stage) app.stage.container().style.cursor = 'crosshair';
            this.reset_state(app);
        },

        deactivate(app) {
            if (app.stage) app.stage.container().style.cursor = 'default';
            // Hide pointer properties panel when deactivating the tool
            this.reset_state(app);
        }
    },

    // Text tool implementation
    add_text: {
        async mouse_down(app, e) {
            // Only handle left mouse button (button 0)
            if (e.evt.button !== 0) return;
            
            // Get click position adjusted for zoom and pan
            const pos = app.get_pointer_position();
            if (!pos) return;
            
            // Create standalone text at click position
            const text_object = await app.create_standalone_text(pos.x, pos.y);
            if (!text_object) return;
            
            // Change to select tool and auto-select the new text
            app.change_tool('select');
            app.select_object(text_object);
            
            // Push to history
            app.push_to_history('create_standalone_text');
        },
        
        activate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'crosshair';
            }
            
            // Clear any balloon edit modes when activating this tool
            app.clear_balloon_edit_modes();
            app.refresh_lucide();
        },
        
        deactivate(app) {
            if (app.stage) {
                app.stage.container().style.cursor = 'default';
            }
        }
    },
    
    // AI Generation tool
    ai_generation: {
        activate(app) {
            if (app.ai_generation_active) {
                app.deactivate_ai_generation_mode();
            } else {
                app.activate_ai_generation_mode();
            }
        },
        deactivate(app) {
            // Handled by activate toggle
            
        }
    },
    
    // AI Library tool  
    ai_library: {
        activate(app) {
            app.show_prompt_library_manager();
            // Return to previous tool after opening library
            setTimeout(() => {
                if (app.previous_tool && app.previous_tool !== 'ai_library') {
                    app.change_tool(app.previous_tool);
                }
            }, 100);
        },
        deactivate(app) {
            // Library is managed through modal, no specific deactivation needed
        }
    }
};

export default tool_handlers;